import * as React from "react";
import { forwardRef } from "react";
const SvgSplitter = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 2, height: 15, viewBox: "0 0 2 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.746 14.5V0.499999H1.824V14.5H0.746Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgSplitter);
export { ForwardRef as ReactComponent };
